import { Form } from 'react-bootstrap';
import './checkboxWithModel.scss';
const CheckboxWithModel = (props) => {
  let myChangeHandler = (event) => {
    let mapTo = event.target.name;
    let val = event.target.checked;
    props.onChangeHandler(mapTo, val);
  };

  let classesForGroup = 'checkbox-With-Model';
  if (props.entry.className) {
    classesForGroup += ' ' + props.entry.className;
  }

  return (
    <Form.Group style={props.entry.style} className={classesForGroup}>
      {
        props.options.map((option) => {
          return (
            <Form.Check
              name={option.mapTo}
              inline={props.entry.inline}
              label={option.label}
              type="checkbox"
              id={`checkboxwithmodel-${option.mapTo}`}
              key={`checkboxwithmodel-${option.mapTo}`}
              defaultChecked={props.value[option.mapToProp]
              }
              onChange={myChangeHandler}
            />
          );
        })
      }
    </Form.Group >
  );
};

export default CheckboxWithModel;
